import dealer_link from './dealer_link.vue'
const DealerLink = {
    install: function (Vue) {
        Vue.component('DealerLink', dealer_link)
    }
}
export default DealerLink
